module.exports = __webpack_public_path__ + "static/6_ConnectCloudflare-7536b033425b9d04b767054353c8c721.jpg";